<template>
	<v-container fluid class="blue-grey lighten-5">
		<v-container grid-list-lg>
			<v-row>
				<v-col>
					<h1 class="font-weight-black black--text text-xs-center my-0">ماژول های پازار نسخه 12</h1>
				</v-col>
			</v-row>

			<v-row justify-center row wrap class="moduls-cards">
				<v-col xs="12" sm="6" v-for="(item, idx) in v12Modules" :key="idx">
					<v-hover>
						<v-card :to="item.link" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`">
							<v-responsive>
								<v-img :src="item.image" height="300px"></v-img>
							</v-responsive>
							<v-card-text>
								<div>
									<h2 class="font-weight-black black--text text-xs-right mb-1">{{ item.text }}</h2>
								</div>
								<v-divider></v-divider>
							</v-card-text>

							<v-card-actions>
								<v-spacer></v-spacer>
								<h3 class="font-weight-thin black--text text-xs-right mb-0">{{ item.price }}</h3>
							</v-card-actions>
						</v-card>
					</v-hover>
				</v-col>
			</v-row>
		</v-container>
	</v-container>
</template>

<script>
	export default {
		name: "V12ModulesCards",
		computed: {
			v12Modules() {
				return this.$store.state.v12Modules;
			},
		},
	};
</script>
